import { ASSESSMENT_STATUSES } from "../movenet/params";
import * as Sentry from "@sentry/browser";

export function SentryLogging(Assessment_types) {
  let event = new Date();
  if (ASSESSMENT_STATUSES.calibration_error_state) {
    ASSESSMENT_STATUSES.calibration_error_state = false;
    ASSESSMENT_STATUSES.sentry_message =
      ASSESSMENT_STATUSES.sentry_message +
      "\n" +
      event.toISOString() +
      ": Calibration ERROR occured";
  } else if (ASSESSMENT_STATUSES.are_you_there == true) {
    ASSESSMENT_STATUSES.are_you_there = false;
    ASSESSMENT_STATUSES.sentry_message =
      ASSESSMENT_STATUSES.sentry_message +
      "\n" +
      event.toISOString() +
      ": Leaving Assessment due to inactivity: Are-You-There Modal";
  } else if (ASSESSMENT_STATUSES.incomplete_test == true) {
    ASSESSMENT_STATUSES.incomplete_test = false;
    ASSESSMENT_STATUSES.sentry_message =
      ASSESSMENT_STATUSES.sentry_message +
      "\n" +
      event.toISOString() +
      ": Leaving with an InComplete Assessment";
  }

  if (ASSESSMENT_STATUSES.assessment_successful_completion) {
    ASSESSMENT_STATUSES.sentry_message =
      ASSESSMENT_STATUSES.sentry_message +
      "\n" +
      event.toISOString() +
      `: Number of retries before successful completion : ${sessionStorage.getItem(
        "retry-counter"
      )} `;

    sessionStorage.setItem("retry-counter", "0");
  }

  console.log(ASSESSMENT_STATUSES.sentry_message);
  Sentry.captureMessage(
    Assessment_types +
      "[" +
      event.toISOString() +
      "]: This message contains the overall assessment report in full_message session.",
    {
      extra: {
        full_message: ASSESSMENT_STATUSES.sentry_message,
      },
    }
  );
  ASSESSMENT_STATUSES.sentry_message = "";
}
